import React, { FC, MouseEvent } from 'react';
import { Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import AddCircleIcon from '@material-ui/icons/AddCircle';

interface IProps {
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
}

const useStyles = makeStyles(theme => ({
  button: {
    background: theme.palette.background.default,
    '&:hover': {
      border: '1px solid transparent',
      background: theme.palette.background.default,
    },
  },
}));

const FiltersButton: FC<IProps> = ({ onClick }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Button
      className={classes.button}
      variant="contained"
      size="large"
      onClick={onClick}
      endIcon={<AddCircleIcon color="primary" />}
    >
      {t('analytics:filters')}
    </Button>
  );
};

export default FiltersButton;
